import React from "react";
import PropTypes from "prop-types";

let API = "{host}/api/v1/get-glyph";
const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;

const checkKind = (id) => {
  // Si no se proporciona un sufijo (kind), establecer el valor por defecto como "m"
  if (!id.includes("-")) {
    id += "-m";
  }
  const words = id.split("-");
  const validKinds = ["s", "m", "l"];
  const suffix = words.pop();
  if (validKinds.includes(suffix)) {
    return id;
  } else {
    return id+'-m';
  }
}

const buildId = (id, kind) => {
  let correctId = null;
  // Para los casos que viene el Id sin '-' y en camel case
  if (/[A-Z]/.test(id)) {
    correctId = id.split(/(?=[A-Z])/).join('-');
    correctId.toLowerCase()
  }
  if (kind && correctId) {
    id = `${correctId}-${kind}`
  } else if (kind && !correctId) {
    id = `${id}-${kind}`
  } else if (!kind && correctId) {
    id = checkKind(correctId)
  } else {
    id = checkKind(id)
  }
  
  return id;
}

const IconGlyph = (props) => {
  let { id, color, className, priority, kind, alt, title } = props;
  let { width, height, insetPosition, dataCy, layoutSize } = props;
  const finalId = buildId(id, kind);
  if(!dataCy){
    dataCy = `${id}`
  }
  const size = {};
  let finalTitle = ""
  if (title) {
    finalTitle = title;
  }

  if (currentEnv !== 'prod') {
    // API = API.replace('{host}', 'https://dev.ssr.col.movistar.es');
    API = API.replace('{host}', 'https://ssr.col.movistar.es');
  } else {
    API = API.replace('{host}', 'https://ssr.col.movistar.es');
  }


  /* Damos valor a la otra coordenada en caso de no indicarse */
  if (width && !height) {
    // Si no está definido el height se le da el valor del width 
    size.height = width;
    if (!layoutSize || !layoutSize.height) {
      layoutSize = { ...layoutSize, width };
    }
  } else if (height && !width) {
    // Si no está definido el width se le da el valor del height 
    size.width = height;
    if (!layoutSize || !layoutSize.width) {
      layoutSize = { ...layoutSize, height };
    }
  } else if (width && height) {
    // Si ambos están definidos y son diferentes, establecer ambos como el valor de width
    size.width = width;
    size.height = width;
  }


  let loadingAttribute = 'eager';
  let fetchPriorityAttribute = 'high';
  if(!priority){
    loadingAttribute = 'lazy';
    fetchPriorityAttribute = 'none'
  }

  let finalClassName = 'svg-layout-size'
  if (className) {
    finalClassName = `${finalClassName} ${className}`;
  }

  let finalAlt = alt || '';
  if (!finalAlt && finalId) {
    finalAlt = finalId
  }

  return (
    <div className={finalClassName} style={{ ...(layoutSize || {}) }}>
      <img
        title={finalTitle}
        data-cy={dataCy}
        src={`${API}/${finalId}/${size.height || height}/${color}`}
        width={size.width || width}
        height={size.height || height}
        style={{ 
          insetPosition,
        }}
        alt={finalAlt}
        loading={loadingAttribute}
        fetchpriority={fetchPriorityAttribute}
      />
    </div>
  );
};
export default IconGlyph;

IconGlyph.propTypes = {
  /**
   * Nombre de icono
  */
  id: PropTypes.string,

  /**
   * Color que tendrá el icono
  */
  color: PropTypes.string,

  /**
   * Define la clase CSS custom que se le aplica al componente
  */
  className: PropTypes.string,

  /**
   * Booleano para agregar o quitar lazy loading
  */
  priority: PropTypes.bool,

  /**
   * Tipo de icono este puede ser:
   *  Light(l): con lineas finas
   *  Medium(m): con lineas gruesas
   *  Solid(s): relleno
  */
  kind: PropTypes.string,

  /**
   * Texto alternativo del icono 
  */
  alt: PropTypes.string,

  /**
   * Ancho en píxeles del icono. Obligatorio excepto cuando se especifica el height o layoutSize.
  */
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  
  /**
   * Alto en píxeles del icono. Obligatorio excepto cuando se especifica el width o layoutSize.
  */
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Identificador necesario para los test
  */
  dataCy: PropTypes.string,

  /**
   * Objeto que define al container del icono un width y height
  */
  layoutSize: PropTypes.shape({
    w: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    h: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
};